import React from "react";
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";

const format = (val) =>
  `₱${(val || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;

const percentDiff = (prev, curr) => {
  if (!prev) return "—";
  const diff = ((curr - prev) / prev) * 100;
  const arrow = diff > 0 ? "↑" : diff < 0 ? "↓" : "→";
  const color = diff > 0 ? "green" : diff < 0 ? "red" : "gray";
  return (
    <span style={{ color }}>
      {arrow} {Math.abs(diff).toFixed(2)}%
    </span>
  );
};

const SalesLeastPopularMenuItem = ({
  data,
  start,
  end,
  prevStart,
  prevEnd,
}) => {
  const leastPopularItems = data?.leastPopularItems;
  if (!leastPopularItems) return null;
  return (
    <Paper sx={{ mt: 4, p: 2 }}>
      <Typography variant="h6" gutterBottom align="center">
        Least Popular Menu Items
      </Typography>
      <Typography
        variant="subtitle2"
        align="center"
        color="text.secondary"
        gutterBottom
      >
        {prevStart.format("MM/DD")}–{prevEnd.format("MM/DD")} vs{" "}
        {start.format("MM/DD")}–{end.format("MM/DD")}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Item</TableCell>
            <TableCell align="right">Prev Qty</TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="right">Curr Qty</TableCell>
            <TableCell align="right">Prev Amt</TableCell>
            <TableCell align="center"></TableCell>
            <TableCell align="right">Curr Amt</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {leastPopularItems.map((item) => (
            <TableRow key={item.name}>
              <TableCell>{item.name}</TableCell>
              <TableCell align="right">{item.qty.previous}</TableCell>
              <TableCell align="center">
                {percentDiff(item.qty.previous, item.qty.current)}
              </TableCell>
              <TableCell align="right">{item.qty.current}</TableCell>
              <TableCell align="right">
                {format(item.amount.previous)}
              </TableCell>
              <TableCell align="center">
                {percentDiff(item.amount.previous, item.amount.current)}
              </TableCell>
              <TableCell align="right">{format(item.amount.current)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default SalesLeastPopularMenuItem;
